import { render } from "./ServiceStockDetails.vue?vue&type=template&id=ed26a6a4&scoped=true"
import script from "./ServiceStockDetails.vue?vue&type=script&lang=js"
export * from "./ServiceStockDetails.vue?vue&type=script&lang=js"

import "./ServiceStockDetails.vue?vue&type=style&index=0&id=ed26a6a4&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed26a6a4"]])

export default __exports__